/**
 * Mobil tam ekranda yatay video için yön kilidi.
 *
 * 16:9 bir filmi dikey ekranda `contain` ile göstermek kaçınılmaz olarak
 * üst/altta siyah bant bırakır. Yatay kilit, görüntüyü kırpmadan ekranı
 * doldurmanın tek kayıpsız yoludur. Desteklemeyen tarayıcılarda (ör. iOS)
 * sessizce yok sayılır.
 */
import { useEffect } from 'react';
import type { VideoAspect } from './useVideoAspect.ts';

interface LockableOrientation {
  lock?: (orientation: string) => Promise<void>;
  unlock?: () => void;
}

export function useLandscapeLock(active: boolean, aspect: VideoAspect | null): void {
  useEffect(() => {
    if (!active || aspect === null || aspect.ratio < 1.2) return;
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return;
    // Yalnız dokunmatik/mobil cihazlarda; masaüstünde yön kilidi anlamsız.
    if (!window.matchMedia('(pointer: coarse)').matches) return;

    const orientation = window.screen?.orientation as LockableOrientation | undefined;
    if (typeof orientation?.lock !== 'function') return;

    void orientation.lock('landscape').catch(() => undefined);
    return () => {
      try {
        orientation.unlock?.();
      } catch {
        // Tarayıcı izin vermiyorsa yön serbest kalır.
      }
    };
  }, [active, aspect]);
}
